import React, { useState, useEffect } from "react";
import "./LatestHappenings.css";

// Grouping the images from your folder screenshot into their respective events
// Added a 'tag' property to each event to display in the card tab
const events = [
  { 
    title: "Sports Day Celebration",
    tag: "ATHLETICS",
    images: ["./Events/image00038.jpeg", "./Events/image00051.jpeg", "./Events/IMG20250317111126.jpg"] 
  },
  { 
    title: "Vista",
    tag: "ANNUAL FEST",
    images: ["./Events/image00006.jpeg", "./Events/image00007.jpeg", "./Events/image00010.jpeg", "./Events/image00089.jpeg"] 
  },
  { 
    title: "Cultural Heritage Festival",
    tag: "CULTURE",
    images: ["./Events/IMG_0585.jpeg", "./Events/IMG_0649.jpeg", "./Events/IMG_0661.jpeg"] 
  },
  { 
    title: "Innovation & Entrepreneurship",
    tag: "WORKSHOP",
    images: ["./Events/image00013.jpeg", "./Events/image00015.jpeg", "./Events/image00028.jpeg"] 
  },
  { 
    title: "Student Science Fair",
    tag: "EXHIBITION",
    images: ["./Events/IMG_0613.jpeg", "./Events/image00077.jpeg", "./Events/image00092.jpeg"] 
  },
  { 
    title: "Farewell Ceremony",
    tag: "CELEBRATION",
    images: ["./Events/image00032.jpeg", "./Events/image00079.jpeg", "./Events/image00087.jpeg"] 
  }
];

// Sub-component to handle state and auto-carousel for EACH card independently
const EventCard = ({ event }) => {
  const [currentImgIndex, setCurrentImgIndex] = useState(0);
  const [isHovered, setIsHovered] = useState(false); 

  const nextSlide = () => {
    setCurrentImgIndex((prev) => (prev === event.images.length - 1 ? 0 : prev + 1));
  };

  const prevSlide = () => {
    setCurrentImgIndex((prev) => (prev === 0 ? event.images.length - 1 : prev - 1));
  };

  // --- Auto Carousel Logic ---
  useEffect(() => {
    let intervalId;
    
    // START timer ONLY if hovered and there are multiple images
    if (event.images.length > 1 && isHovered) {
      intervalId = setInterval(() => {
        setCurrentImgIndex((prev) => (prev === event.images.length - 1 ? 0 : prev + 1));
      }, 2000); // Set to 2 seconds for a slightly snappier hover effect
    }

    // Clear timer when un-hovered
    return () => {
      if (intervalId) {
        clearInterval(intervalId);
      }
    };
  }, [event.images.length, isHovered]);

  return (
    <div 
      className="lh-event-card"
      onMouseEnter={() => setIsHovered(true)}   // Start carousel
      onMouseLeave={() => setIsHovered(false)}  // Pause carousel
    >
      <div className="lh-card-tab">
        {/* Replaced the index number with the specific event tag */}
        <span className="lh-tab-text">{event.tag}</span>
      </div>

      <div className="lh-card-body">
        <div className="lh-image-wrapper">
          
          {/* Render ALL images and crossfade them using CSS classes */}
          {event.images.map((imgSrc, i) => (
             <img 
               key={i}
               src={imgSrc} 
               alt={`${event.title} - ${i + 1}`} 
               // Only the active index gets the "active" class
               className={`lh-event-image ${i === currentImgIndex ? "active" : ""}`} 
             />
          ))}

          {/* Carousel Controls */}
          {event.images.length > 1 && (
            <>
              <button className="lh-carousel-btn left" onClick={prevSlide}>&#10094;</button>
              <button className="lh-carousel-btn right" onClick={nextSlide}>&#10095;</button>
              
              <div className="lh-carousel-dots">
                {event.images.map((_, i) => (
                  <span 
                    key={i} 
                    className={`lh-dot ${i === currentImgIndex ? "active" : ""}`}
                    onClick={() => setCurrentImgIndex(i)}
                  ></span>
                ))}
              </div>
            </>
          )}
        </div>

        <div className="lh-card-main">
          <div className="lh-event-title">{event.title}</div>
          <div className="lh-corner-tl"></div>
          <div className="lh-corner-br"></div>
        </div>
      </div>
    </div>
  );
};

const LatestHappenings = () => {
  return (
    <div className="lh-container">
      <div className="rs5865f2-titleWrap">
        <div className="rs5865f2-titleRow">
          <div className="rs5865f2-titlePlain">Our</div>
          <div className="rs5865f2-titleGradient">Events</div>
        </div>
        <div className="rs5865f2-gradientLine" />
      </div>
      
      <div className="lh-events-grid">
        {events.map((event, index) => (
          <EventCard key={index} event={event} />
        ))}
      </div>
    </div>
  );
};

export default LatestHappenings;